<template>
  <div class="wrapper container">
    <div v-for="(item, index) in data" :key="index" class="partner">
      <img :src="item" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style lang='scss' scoped>
@import '@/style/app.sass';

.wrapper {
  display: flex;
  flex-wrap: wrap;
  .partner {
    width: 16.6667%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
    }
    @include mobile {
      width: 33.3333%;
    }
  }
}
</style>
